export default function (elem) {
	if (!window.ll) {
		window.ll = new LazyLoad({
			elements_selector: '.banner'
		});
	} else {
		window.ll.update();
	}
	if (!!elem) window.ll.load(elem, true);
}